import Constants from './Constants';
import checkStatus from '../utils/checkStatus';
import Dispatcher from './Dispatcher';

export default {
  getCountries() {
    return fetch(`${Constants.BASE_URL}/countries`)
      .then(checkStatus)
      .then(response => response.json())
      .then(countries => Dispatcher.dispatch({
        actionType: Constants.COUNTRIES_CHANGED,
        countries,
      }));
  }
}



// WEBPACK FOOTER //
// ./src/flux/ApiManager.js